import { Button, Col, Form, Modal, Row } from "@themesberg/react-bootstrap";
import { string } from "prop-types";
import { useContext, useEffect } from "react";
import { useState } from "react";
import ToastPopup from "src/app/common/ToastPopup";
import { AdvertContext } from "src/app/contexts/AdvertContext";
import Schema from "validate";

const convertDateFormat = (date) => {
	let dateObj = new Date(date);
	const offset = dateObj.getTimezoneOffset();
	dateObj = new Date(dateObj.getTime() - offset * 60 * 1000);
	return (
		dateObj.toISOString().split("T")?.[0] +
		" " +
		dateObj.toISOString().split("T")?.[1]?.split(".")?.[0]
	);
};


const advertSchema = new Schema({
	name: {
		type: String,
		required: true,
		length: { min: 3, max: 150 },
	},
	page: {
		type: String,
		required: true,
	},
	place: {
		type: String,
		required: true,
	},
	type: {
		type: String,
		required: true,
	},
	priority: {
		type: Number,
		required: true,
		size: { min: 1, max: 5000 },
	},
	link: {
		type: String,
	}
});

const AdvertModal = ({ showAddEditModal, setShowAddEditModal, editData, setEditData }) => {
	const [advertData, setAdvertData] = useState({});
	const { advertConfig, getAllAdvertConfig, getAllAdverts, updateAdvertise, createAdvertise } =
		useContext(AdvertContext);

	const handleInputChange = (e) => {
		if (!e?.target?.name || !e?.target?.value) return;

		console.log(" input change: ", advertData);

		if (e?.target?.name === "imageUrl" || e?.target?.name === "mobileImageUrl") {
			setAdvertData({
				...advertData,
				[e?.target?.name]: e?.target?.files?.[0],
			});
		} else if (e?.target?.name === "page") {
			setAdvertData({
				...advertData,
				page: e.target.value,
				place: "place",
				type: "type",
			});
		} else if (e?.target?.name === "place") {
			setAdvertData({
				...advertData,
				place: e.target.value,
				type: "type",
			});
		} else if (e?.target?.name === "priority") {
			setAdvertData({
				...advertData,
				priority: +e.target.value,
			});
		} else if (e?.target?.name === "expires_on") {
			setAdvertData({
				...advertData,
				expires_on: convertDateFormat(e?.target?.value),
			});
		} else if (e?.target?.name === "link") {
			setAdvertData({
				...advertData,
				link: e.target.value,
			});
		} else {
			setAdvertData({
				...advertData,
				[e?.target?.name]: e?.target?.value,
			});
		}
	};

	const handleUpdateOrSubmitButton = () => {
		console.log(advertData);
		const error = advertSchema.validate(advertData, { strip: false });

		if (error?.length > 0) {
			ToastPopup("error", error?.[0]?.message);
			return;
		} else if (!advertData?.expires_on) {
			ToastPopup("error", "Expiry date is required!!");
			return;
		} else if (!advertData?.imageUrl && !editData) {
			ToastPopup("error", "Advert image is required!!");
			return;
		}

		let formdata = new FormData();
		formdata.append("name", advertData?.name);
		formdata.append("page", advertData?.page);
		formdata.append("place", advertData?.place);
		formdata.append("type", advertData?.type);
		formdata.append("link", advertData?.link);
		formdata.append("priority", advertData?.priority);
		formdata.append("expires_on", convertDateFormat(advertData?.expires_on));
		typeof advertData?.imageUrl === "object" && formdata.append("image", advertData?.imageUrl);
		advertData?.["mobileImageUrl"] &&
			formdata.append("mobile_image", advertData?.["mobileImageUrl"]);

		if (editData) {
			updateAdvertise(advertData?.id, formdata, () => {
				setEditData(null);
				setShowAddEditModal(!setShowAddEditModal);
				getAllAdverts();
			});
		} else {
			createAdvertise(formdata, () => {
				setShowAddEditModal(!setShowAddEditModal);
				getAllAdverts();
			});
		}
	};

	useEffect(() => {
		getAllAdvertConfig();
	}, []);

	useEffect(() => {
		console.log("miraz: ", advertData);
	}, [advertData]);

	useEffect(() => {
		if (editData) {
			setAdvertData(editData);
		}
	}, [editData]);

	console.log("editdata: ", editData);
	console.log("advertData: ", advertData);

	return (
		<Modal
			centered
			size="lg"
			className="modal-tertiary"
			show={showAddEditModal}
			onHide={() => {}}
		>
			<Modal.Header>
				<Button
					variant="close"
					className="btn-close-dark text-dark"
					aria-label="Close"
					onClick={() => {
						setShowAddEditModal(false);
					}}
				/>
			</Modal.Header>
			<Modal.Body className=" py-3">
				<div className="px-5">
					<center>
						<h5 className="mb-4">{editData ? "Edit Advert" : "Add Advert"}</h5>
					</center>
					<Row>
						<Col md={6} className="mb-3">
							<Form.Group id="advertName">
								<Form.Label>Name</Form.Label>
								<Form.Control
									required
									type="text"
									name="name"
									value={advertData?.["name"] ?? ""}
									onChange={(e) => handleInputChange(e)}
									placeholder="Enter Name"
								/>
							</Form.Group>
						</Col>
						<Col md={6} className="mb-3">
							<Form.Group id="advertPage">
								<Form.Label>Page</Form.Label>
								<Form.Select
									required
									name="page"
									value={advertData?.["page"] ?? "page"}
									onChange={(e) => handleInputChange(e)}
								>
									<option value="page">Select page</option>
									{advertConfig?.places?.pages?.map((page) => (
										<option value={page}>{page}</option>
									))}
								</Form.Select>
							</Form.Group>
						</Col>
					</Row>

					<Row>
						<Col md={6} className="mb-3">
							<Form.Group id="advertPlace">
								<Form.Label>Place</Form.Label>
								<Form.Select
									required
									name="place"
									value={advertData?.["place"] ?? "place"}
									onChange={(e) => handleInputChange(e)}
								>
									<option value="place">Select place</option>
									{advertConfig?.places?.places?.[
										advertData?.["page"] ?? ""
									]?.map((place) => (
										<option value={place}>{place}</option>
									))}
								</Form.Select>
							</Form.Group>
						</Col>

						<Col md={6} className="mb-3">
							<Form.Group id="advertType">
								<Form.Label>Type</Form.Label>
								<Form.Select
									required
									name="type"
									value={advertData?.["type"] ?? "type"}
									onChange={(e) => handleInputChange(e)}
								>
									<option value="type">Select type</option>
									{advertConfig?.places?.dimens?.[advertData?.["page"] ?? ""]?.[
										advertData?.["place"] ?? ""
									]?.map((type) => (
										<option value={type}>{type}</option>
									))}
								</Form.Select>
							</Form.Group>
						</Col>
					</Row>

					<Row>
						<Col md={6} className="mb-3">
							<Form.Group id="advertPriority">
								<Form.Label>Priority</Form.Label>
								<Form.Control
									required
									type="number"
									name="priority"
									value={advertData?.["priority"] ?? 0}
									onChange={(e) => handleInputChange(e)}
									placeholder="Enter priority value"
								/>
							</Form.Group>
						</Col>

						<Col md={6} className="mb-3">
							<Form.Group id="advertExpiry">
								<Form.Label>Expire on</Form.Label>
								<Form.Control
									required
									type="datetime-local"
									name="expires_on"
									value={
										advertData?.["expires_on"]
											? new Date(
													new Date(advertData?.["expires_on"]).getTime() -
														new Date(
															advertData?.["expires_on"]
														).getTimezoneOffset() *
															60000
											  )
													.toISOString()
													.split(".")?.[0]
											: ""
									}
									onChange={(e) => handleInputChange(e)}
									placeholder="Enter exprity date"
								/>
							</Form.Group>
						</Col>
					</Row>
					<Row>
						<Col md={12} className="mb-3">
							<Form.Group id="advertLink">
								<Form.Label>Link</Form.Label>
								<Form.Control
									type="text"
									name="link"
									value={advertData?.["link"] ?? ''}
									onChange={(e) => handleInputChange(e)}
									placeholder="Enter link"
								/>
							</Form.Group>
						</Col>
					</Row>
					{advertConfig?.types?.filter((type) => type?.type === advertData?.["type"])
						?.length > 0 && (
						<>
							<Row>
								<Col className="text-center">
									{advertData?.imageUrl &&
										(typeof advertData?.imageUrl === "string" ? (
											<img src={advertData?.imageUrl} alt="" width={150} />
										) : (
											<img
												src={URL.createObjectURL(advertData?.imageUrl)}
												alt=""
												width={150}
											/>
										))}
								</Col>
							</Row>
							<Row>
								<Col md={12} className="mb-3">
									<Form.Group id="advertImage">
										<Form.Label>
											Upload Image
											{"( " +
												advertConfig?.types?.filter(
													(type) => type?.type === advertData?.["type"]
												)?.[0]?.["width"] +
												" x " +
												advertConfig?.types?.filter(
													(type) => type?.type === advertData?.["type"]
												)?.[0]?.["height"] +
												" )"}
										</Form.Label>
										<Form.Control
											required
											type="file"
											name="imageUrl"
											onChange={(e) => handleInputChange(e)}
										/>
									</Form.Group>
								</Col>
							</Row>
						</>
					)}

					{advertConfig?.types?.filter(
						(type) => type?.type === advertData?.["type"]
					)?.[0]?.["mobile"] && (
						<>
							<Row>
								<Col className="text-center">
									{advertData?.mobileImageUrl &&
										(typeof advertData?.mobileImageUrl === "string" ? (
											<img
												src={advertData?.mobileImageUrl}
												alt=""
												width={150}
											/>
										) : (
											<img
												src={URL.createObjectURL(
													advertData?.mobileImageUrl
												)}
												alt=""
												width={150}
											/>
										))}
								</Col>
							</Row>
							<Row>
								<Col md={12} className="mb-3">
									<Form.Group id="advertMobileImage">
										<Form.Label>
											Upload Mobile Image (
											{advertConfig?.types?.filter(
												(type) => type?.type === advertData?.["type"]
											)?.[0]?.["mobile"]?.["width"] +
												" x " +
												advertConfig?.types?.filter(
													(type) => type?.type === advertData?.["type"]
												)?.[0]?.["mobile"]?.["height"]}
											)
										</Form.Label>
										<Form.Control
											required
											type="file"
											name="mobileImageUrl"
											onChange={(e) => handleInputChange(e)}
										/>
									</Form.Group>
								</Col>
							</Row>
						</>
					)}
				</div>
			</Modal.Body>
			<Modal.Footer className="z-2 text-end">
				<Row>
					<Col lg={12}>
						<div className="mx-4 text-end">
							<Button variant="dark" onClick={() => handleUpdateOrSubmitButton()}>
								{editData ? "Update" : "Submit"}
							</Button>
						</div>
					</Col>
				</Row>
			</Modal.Footer>
		</Modal>
	);
};

export default AdvertModal;
